import headerSocialIconsActiveRule from '../../../common/algorithms/header-social-icons-active-rule';

const primary = (params) => headerSocialIconsActiveRule(params);

export default primary;
